import api from './axiosInterceptors';
import { API_ENDPOINTS } from './apiEndpoints';

export type LoginResponse = {
  accessToken: string;
  expiresIn: number;
};

export async function loginWithToken(token: string): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>(API_ENDPOINTS.login, { token });
  return data;
}
